"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = function (courseList, requiredCourseTitles) {
    if (courseList === void 0) { courseList = []; }
    if (requiredCourseTitles === void 0) { requiredCourseTitles = []; }
    return requiredCourseTitles
        .filter(function (requiredCourseSet) {
        var requiredCourseSetArr = !Array.isArray(requiredCourseSet)
            ? [requiredCourseSet]
            : requiredCourseSet;
        return !courseList.find(function (course) {
            return !!requiredCourseSetArr.find(function (courseTitle) {
                return courseTitle.toLowerCase().trim() ===
                    course.course_title.toLowerCase().trim();
            });
        });
    })
        .map(function (issue) { return (Array.isArray(issue) ? "one of: " + issue.join(", ") : issue); });
};
//# sourceMappingURL=findCoursesMissingFromCourseList.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/utils/findCoursesMissingFromCourseList.js
// module id = 463
// module chunks = 22